import { create } from 'zustand';
import type { FloorPlan, Table } from '@/lib/types';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

interface TableState {
  floorPlans: FloorPlan[];
  tables: Record<string, Table>;
  selectedTableId: string | null;

  setFloorPlans: (plans: FloorPlan[]) => void;
  setTables: (tables: Table[]) => void;
  selectTable: (id: string | null) => void;
  getSelectedTable: () => Table | null;
}

// ---------------------------------------------------------------------------
// Store (runtime only — NOT persisted)
// ---------------------------------------------------------------------------

export const useTableStore = create<TableState>()((set, get) => ({
  floorPlans: [],
  tables: {},
  selectedTableId: null,

  setFloorPlans: (plans) => set({ floorPlans: plans }),

  setTables: (tables) => {
    const record: Record<string, Table> = {};
    for (const table of tables) {
      record[table.id] = table;
    }
    set({ tables: record });
  },

  selectTable: (id) => set({ selectedTableId: id }),

  getSelectedTable: () => {
    const { tables, selectedTableId } = get();
    if (!selectedTableId) return null;
    return tables[selectedTableId] ?? null;
  },
}));
